import _ from "lodash";
import moment from "moment";

export const removeHTMLTags = (content) => {
  if(_.isEmpty(content)) {
    return '';
  }
  const regex = /(<([^>]+)>)/ig;
  return content.replace(regex, '').replace(/&nbsp;/ig, '').replace(/(^\s*)|(\s*$)/g, '');
}

export const dateFMT = (date) => {
  return moment(date).format('YYYY-MM-DD');
}

export const dateFMT4PHP = (date) => {
  return moment(date * 1000).format('YYYY-MM-DD');
}
